<template>
  <div class="fixed inset-0 z-30 flex flex-col items-center bg-[#0a0f18] font-sans overflow-hidden">
    <canvas ref="canvasRef" class="absolute inset-0 z-0"></canvas>

    <div class="relative z-10 w-full max-w-md bg-[#f4f5f9] h-full flex flex-col shadow-2xl overflow-hidden">
      <header class="bg-[#1e2532] text-white p-5 shadow-lg rounded-b-3xl relative overflow-hidden shrink-0">
        <div class="relative z-10 flex items-center justify-between">
          <div class="flex items-center">
            <button @click="$router.push('/')" class="mr-3 text-white hover:text-gray-300">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
            </button>
            <div>
              <h1 class="text-xl font-extrabold mb-1">내 지갑</h1>
              <p class="text-xs text-gray-300">누적 수당 및 출금 관리</p>
            </div>
          </div>
          <button @click="handleLogout" class="text-xs font-bold bg-red-600 px-3 py-1.5 rounded hover:bg-red-700 transition-colors shadow-sm">
            로그아웃
          </button>
        </div>
        <div class="absolute -right-10 -top-10 w-40 h-40 bg-white opacity-5 rounded-full blur-2xl"></div>
      </header>

<main class="p-5 -mt-6 relative z-20 space-y-6 flex-1 overflow-y-auto">
        <!-- 1. 출금 가능 잔액 카드 -->
        <div class="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 relative overflow-hidden">
          <div class="absolute top-0 right-0 w-24 h-24 bg-blue-50 rounded-bl-full -z-10"></div>
          <div class="flex justify-between items-end mb-2">
            <p class="text-sm font-bold text-gray-600">출금 가능 잔액</p>
            <button @click="loadData" class="text-[10px] bg-gray-100 text-gray-500 px-2 py-1 rounded font-bold hover:bg-gray-200">새로고침 ↻</button>
          </div>
          
          <!-- [수정] 큰 숫자 클릭 시 전체 출금가능 보너스 모달 열기 -->
          <h2 @click="openDetailModal('all')" class="text-3xl font-black text-blue-600 mb-4 cursor-pointer hover:text-blue-800 transition-colors group">
            {{ formatNumber(availableBalance) }}<span class="text-lg font-bold text-gray-500 ml-1 group-hover:text-blue-600 transition-colors">원</span>
            <svg class="w-5 h-5 inline text-gray-300 group-hover:text-blue-400 ml-1 -mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
          </h2>
          
          <div class="grid grid-cols-3 gap-2 py-4 border-t border-gray-100 text-center">
            <!-- [수정] 클릭 이벤트 부여 -->
            <div @click="openDetailModal('group_basic')" class="cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors group">
              <p class="text-[10px] text-gray-400 font-bold mb-1">판매/매칭/대수</p>
              <p class="text-xs font-extrabold text-gray-700 flex items-center justify-center">
                {{ formatNumber((wallet.판매||0) + (wallet.매칭||0) + (wallet.대수||0)) }}
                <svg class="w-3 h-3 ml-1 text-gray-300 group-hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
              </p>
            </div>
            <!-- [수정] 클릭 이벤트 부여 -->
            <div @click="openDetailModal('group_cycle')" class="border-l border-gray-100 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors group">
              <p class="text-[10px] text-gray-400 font-bold mb-1">싸이클 보너스</p>
              <p class="text-xs font-extrabold text-gray-700 flex items-center justify-center">
                {{ formatNumber(wallet.싸이클 || 0) }}
                <svg class="w-3 h-3 ml-1 text-gray-300 group-hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
              </p>
            </div>
            <!-- [수정] 클릭 이벤트 부여 -->
            <div @click="openDetailModal('group_etc')" class="border-l border-gray-100 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors group">
              <p class="text-[10px] text-gray-400 font-bold mb-1">기타 (스타/영업소)</p>
              <p class="text-xs font-extrabold text-gray-700 flex items-center justify-center">
                {{ formatNumber((wallet.스타||0) + (wallet.영업소관리||0) + (wallet.영업소소개||0)) }}
                <svg class="w-3 h-3 ml-1 text-gray-300 group-hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
              </p>
            </div>
          </div>
          <div v-if="(wallet.출금요청 || 0) < 0" class="mt-2 pt-2 border-t border-gray-100 text-right">
            <p class="text-[10px] text-red-500 font-bold">누적 출금(요청) 차감액: {{ formatNumber(wallet.출금요청) }} 원</p>
          </div>
        </div>

        <div class="bg-gray-100 rounded-2xl p-5 border border-gray-200">
          <div class="flex justify-between items-center mb-3">
            <h3 class="text-sm font-extrabold text-gray-800">⏳ 지급 대기 수당 (정산 중)</h3>
            <span class="text-xs font-black text-red-500">{{ formatNumber(pendingBalance) }} 원</span>
          </div>
          
          <div class="bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-xs text-gray-600 space-y-2 leading-relaxed">
            <p class="font-bold text-blue-700 mb-1 border-b pb-1">수당별 출금 가능 전환 시점</p>
            <ul class="space-y-1.5 font-medium">
              <li><span class="font-bold text-gray-800">판매/매칭/대수:</span> 발생일 기준 <span class="text-red-500 font-bold">3일째</span> 지급</li>
              <li><span class="font-bold text-gray-800">싸이클/영업소:</span> 주마감 후 <span class="text-red-500 font-bold">익주 수요일</span> 지급</li>
              <li><span class="font-bold text-gray-800">스타 보너스:</span> 15일 마감(<span class="text-red-500 font-bold">20일</span> 지급), 말일 마감(<span class="text-red-500 font-bold">익월 5일</span> 지급)</li>
            </ul>
            <p class="text-[10px] text-gray-400 mt-2 pt-2 border-t">* 출금 신청 시 다음 날(영업일 기준) 입금 처리됩니다.</p>
          </div>
        </div>

        <div class="bg-white rounded-2xl shadow-md p-6 border border-gray-100">
          <h3 class="text-lg font-extrabold text-gray-800 mb-4 flex items-center">
            <svg class="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
            출금 신청
          </h3>
          
          <div class="bg-blue-50 p-3 rounded-lg mb-5 border border-blue-100">
            <p class="text-xs text-blue-800 font-semibold">
              등록된 계좌: {{ userAccount || '계좌 정보가 없습니다. (정보수정 요망)' }}
            </p>
          </div>

          <form @submit.prevent="prepareWithdrawal">
            <label class="block text-xs font-bold text-gray-700 mb-2">출금할 금액 (최소 1만원 이상)</label>
            <div class="relative mb-2">
              <input 
                type="number" 
                v-model="withdrawAmount" 
                class="w-full px-4 py-3 bg-[#f4f5f9] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 font-bold text-gray-800 pr-12 transition-all"
                placeholder="0"
              />
              <span class="absolute right-4 top-3.5 text-gray-400 font-bold text-sm">원</span>
            </div>
            
            <div class="flex justify-end mb-6 space-x-2">
              <button type="button" @click="setAmount(10000)" class="px-3 py-1 bg-gray-100 text-gray-600 rounded text-xs font-bold hover:bg-gray-200">+1만</button>
              <button type="button" @click="setAmount(50000)" class="px-3 py-1 bg-gray-100 text-gray-600 rounded text-xs font-bold hover:bg-gray-200">+5만</button>
              <button type="button" @click="setAmount(availableBalance)" class="px-3 py-1 bg-blue-100 text-blue-700 rounded text-xs font-bold hover:bg-blue-200">전액</button>
            </div>

            <button 
              type="submit" 
              :disabled="!isValidAmount"
              class="w-full bg-[#1e2532] text-white font-bold py-3.5 rounded-xl hover:bg-black transition-colors shadow-lg disabled:opacity-50"
            >
              출금 신청하기
            </button>
          </form>
        </div>

        <div class="bg-white rounded-2xl shadow-sm p-6 border border-gray-100 mb-8">
          <h3 class="text-sm font-extrabold text-gray-800 mb-4">나의 출금 신청 내역</h3>
          
          <ul class="space-y-3">
            <li v-for="item in withdrawalHistory" :key="item.id" class="p-4 bg-gray-50 border border-gray-100 rounded-xl flex justify-between items-center">
              <div>
                <div class="flex items-center space-x-2 mb-1">
                  <span :class="{
                    'bg-yellow-100 text-yellow-700': item.status === 'PENDING',
                    'bg-orange-100 text-orange-700': item.status === 'HOLD',
                    'bg-green-100 text-green-700': item.status === 'COMPLETED',
                    'bg-red-100 text-red-700': item.status === 'CANCELLED' || item.status === 'DELETED'
                  }" class="px-2 py-0.5 text-[10px] font-bold rounded">
                    {{ statusText(item.status) }}
                  </span>
                  <span class="text-[10px] text-gray-400">{{ formatDate(item.createdAt) }}</span>
                </div>
                <p class="text-xs text-gray-600 font-medium truncate max-w-[180px]">{{ item.accountInfo }}</p>
              </div>
              <div class="text-right">
                <p class="text-sm font-extrabold text-gray-800">{{ formatNumber(item.amount) }}원</p>
                <p class="text-[10px] font-bold text-blue-600">실입금: {{ formatNumber(item.netAmount) }}원</p>
              </div>
            </li>
            <li v-if="withdrawalHistory.length === 0" class="text-center py-6 text-xs text-gray-500 font-bold">
              출금 신청 내역이 없습니다.
            </li>
          </ul>
        </div>

      </main>
    </div>

    <!-- 하단 필수 메뉴 아이콘 그리드 -->
    <div class="fixed bottom-0 w-full max-w-md bg-white border-t border-gray-200 p-4 pb-8 z-40">
      <div class="grid grid-cols-4 gap-2">
        <router-link to="/package-purchase" class="flex flex-col items-center justify-center p-2 rounded-lg hover:bg-blue-50 transition group">
          <div class="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-2 group-hover:bg-blue-600 group-hover:text-white transition shadow-sm"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path></svg></div>
          <span class="text-[11px] font-bold text-gray-700 text-center">패키지<br/>구매</span>
        </router-link>
        <router-link to="/wallet" class="flex flex-col items-center justify-center p-2 rounded-lg hover:bg-green-50 transition group">
          <div class="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-2 group-hover:bg-green-600 group-hover:text-white transition shadow-sm"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg></div>
          <span class="text-[11px] font-bold text-gray-700 text-center">지갑/<br/>출금</span>
        </router-link>
        <router-link to="/tree" class="flex flex-col items-center justify-center p-2 rounded-lg hover:bg-purple-50 transition group">
          <div class="w-12 h-12 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mb-2 group-hover:bg-purple-600 group-hover:text-white transition shadow-sm"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg></div>
          <span class="text-[11px] font-bold text-gray-700 text-center">조직도/<br/>계보도</span>
        </router-link>
        <router-link to="/profile" class="flex flex-col items-center justify-center p-2 rounded-lg hover:bg-gray-100 transition group">
          <div class="w-12 h-12 bg-gray-200 text-gray-600 rounded-full flex items-center justify-center mb-2 group-hover:bg-gray-600 group-hover:text-white transition shadow-sm"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg></div>
          <span class="text-[11px] font-bold text-gray-700 text-center">정보<br/>수정</span>
        </router-link>
      </div>
    </div>

    <!-- [상세 내역 확인 모달창] -->
    <div v-if="showDetailModal" class="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black bg-opacity-60 transition-opacity">
      <div class="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-md h-[70vh] sm:h-auto sm:max-h-[80vh] flex flex-col overflow-hidden shadow-2xl transform transition-transform duration-300">
        <div class="bg-[#1e2532] p-4 flex justify-between items-center shrink-0">
          <h3 class="text-white font-bold">{{ modalTitle }} 상세 내역</h3>
          <button @click="closeDetailModal" class="text-gray-300 hover:text-white transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>
        <div class="p-4 overflow-y-auto flex-1 bg-gray-50">
          <div v-if="isModalLoading" class="text-center py-10">
            <p class="text-sm font-bold text-blue-600 animate-pulse">내역을 불러오는 중...</p>
          </div>
          <div v-else-if="modalDataList.length === 0" class="text-center py-10">
            <p class="text-sm text-gray-500 font-bold">해당 내역이 없습니다.</p>
          </div>
          <div v-else class="space-y-3">
            <div v-for="item in modalDataList" :key="item.id" class="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <div class="flex justify-between items-start mb-2">
                <div>
                  <span class="px-2 py-0.5 bg-blue-100 text-blue-700 text-[10px] font-bold rounded">{{ item.bonusType }} 보너스</span>
                  <p class="text-xs text-gray-800 font-bold mt-1.5">{{ item.description }}</p>
                </div>
                <div class="text-right">
                  <p class="text-sm font-black text-green-600">+{{ formatNumber(item.amount) }} 원</p>
                </div>
              </div>
              <div class="pt-2 mt-2 border-t border-gray-100 text-[10px] text-gray-500 flex justify-between">
                <span>{{ formatDate(item.createdAt) }}</span>
                <span v-if="item.sourceName">발생: {{ item.sourceName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 모달 끝 -->

    <div v-if="showPinSetupModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-4">
      <div class="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl relative">
        <h3 class="text-lg font-extrabold text-gray-800 mb-2">출금 PIN 번호 등록</h3>
        <p class="text-xs text-gray-500 mb-6 font-semibold">안전한 출금을 위해 6자리 결제 비밀번호를 최초 1회 등록해야 합니다.</p>
        <form @submit.prevent="savePinNumber" class="space-y-4">
          <div><label class="block text-xs font-bold text-gray-700 mb-1">PIN 번호 (숫자 6자리)</label><input type="password" v-model="pinSetupInput" maxlength="6" pattern="\d{6}" required class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-center tracking-[1em] text-lg font-black focus:outline-none focus:border-blue-500" placeholder="••••••" /></div>
          <div><label class="block text-xs font-bold text-gray-700 mb-1">PIN 번호 확인</label><input type="password" v-model="pinConfirmInput" maxlength="6" pattern="\d{6}" required class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-center tracking-[1em] text-lg font-black focus:outline-none focus:border-blue-500" placeholder="••••••" /></div>
          <p v-if="pinSetupError" class="text-red-500 text-xs font-bold text-center">{{ pinSetupError }}</p>
          <div class="flex space-x-2 pt-2"><button type="button" @click="showPinSetupModal = false" class="flex-1 bg-gray-200 text-gray-700 font-bold py-3 rounded-xl hover:bg-gray-300">취소</button><button type="submit" class="flex-1 bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 shadow-md">등록하기</button></div>
        </form>
      </div>
    </div>

    <div v-if="showWithdrawConfirmModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-4">
      <div class="bg-white rounded-2xl w-full max-w-sm overflow-hidden shadow-2xl">
        <div class="bg-[#1e2532] p-4 text-center"><h3 class="text-white font-bold text-lg">출금 신청 확인</h3></div>
        <div class="p-6">
          <div class="bg-gray-50 rounded-xl p-4 border border-gray-100 mb-5 space-y-3">
            <div class="flex justify-between items-center"><span class="text-xs font-bold text-gray-500">신청 금액</span><span class="text-sm font-bold text-gray-800">{{ formatNumber(withdrawAmount) }} 원</span></div>
            <div class="flex justify-between items-center text-red-500"><span class="text-xs font-bold">시스템 수수료 (5%)</span><span class="text-sm font-bold">- {{ formatNumber(feeAmount) }} 원</span></div>
            <div class="flex justify-between items-center border-t border-gray-200 pt-3"><span class="text-sm font-bold text-blue-600">실제 입금 예정액</span><span class="text-xl font-black text-blue-700">{{ formatNumber(netAmount) }} 원</span></div>
          </div>
          <form @submit.prevent="executeWithdrawal">
            <label class="block text-xs font-bold text-gray-700 mb-2 text-center">출금 PIN 번호 입력</label>
            <input type="password" v-model="pinInput" maxlength="6" required class="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-center tracking-[1em] text-xl font-black mb-2 focus:outline-none focus:border-blue-500" placeholder="••••••" />
            <p v-if="pinError" class="text-red-500 text-xs font-bold text-center mb-4">{{ pinError }}</p>
            <div class="flex space-x-2 mt-4"><button type="button" @click="showWithdrawConfirmModal = false" class="flex-1 bg-gray-200 text-gray-700 font-bold py-3 rounded-xl hover:bg-gray-300">취소</button><button type="submit" :disabled="isProcessing" class="flex-1 bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 shadow-md disabled:opacity-50">{{ isProcessing ? '처리중...' : '최종 신청' }}</button></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { auth, db } from '../../firebase';
import { signOut } from 'firebase/auth'; // 로그아웃을 위해 추가
import { doc, getDoc, updateDoc, addDoc, collection, query, where, getDocs, serverTimestamp, increment, orderBy } from 'firebase/firestore';
import router from '../../router';

export default {
  name: 'WalletWithdrawal',
  setup() {
    const wallet = ref({});
    const pendingWallet = ref({}); 
    const userAccount = ref('');
    const userPin = ref(null);
    const withdrawalHistory = ref([]);
    const withdrawAmount = ref('');
    const isProcessing = ref(false);

    const showPinSetupModal = ref(false);
    const showWithdrawConfirmModal = ref(false);
    const pinSetupInput = ref('');
    const pinConfirmInput = ref('');
    const pinSetupError = ref('');
    const pinInput = ref('');
    const pinError = ref('');

    // 배경 캔버스 관련
    const canvasRef = ref(null);
    let ctx = null; 
    let animationFrameId = null; 
    const particles = []; 
    const particleCount = 60;

    // 모달 관련 상태
    const showDetailModal = ref(false);
    const isModalLoading = ref(false);
    const modalTitle = ref('');
    const modalDataList = ref([]);

    const availableBalance = computed(() => {
      const w = wallet.value;
      const totalBonus = (w.판매 || 0) + (w.매칭 || 0) + (w.대수 || 0) + (w.싸이클 || 0) + (w.스타 || 0) + (w.영업소관리 || 0) + (w.영업소소개 || 0);
      const requested = w.출금요청 || 0; 
      return totalBonus + requested;
    });

    // ⭐️ 대기 지갑에 있는 모든 항목을 안전하게 합산합니다.
    const pendingBalance = computed(() => {
      const p = pendingWallet.value;
      if (!p) return 0;
      return (p.판매 || 0) + (p.매칭 || 0) + (p.대수 || 0) + (p.싸이클 || 0) + (p.스타 || 0) + (p.영업소관리 || 0) + (p.영업소소개 || 0);
    });
    const isValidAmount = computed(() => Number(withdrawAmount.value) >= 10000 && Number(withdrawAmount.value) <= availableBalance.value && userAccount.value && !isProcessing.value);
    const feeAmount = computed(() => Math.floor(Number(withdrawAmount.value) * 0.05));
    const netAmount = computed(() => Number(withdrawAmount.value) - feeAmount.value);

    const formatNumber = (num) => new Intl.NumberFormat('ko-KR').format(num || 0);
    const formatDate = (timestamp) => { if (!timestamp) return '-'; const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp); return `${date.getFullYear().toString().slice(2)}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`; };
    const statusText = (status) => { const map = { 'PENDING': '대기중', 'HOLD': '보류됨', 'COMPLETED': '지급완료', 'CANCELLED': '취소됨(반환)', 'DELETED': '삭제됨(반환)' }; return map[status] || status; };

    const setAmount = (amount) => {
      if (amount === availableBalance.value) withdrawAmount.value = amount;
      else { withdrawAmount.value = Number(withdrawAmount.value || 0) + amount; if (withdrawAmount.value > availableBalance.value) withdrawAmount.value = availableBalance.value; }
    };

    const loadData = async () => {
      const user = auth.currentUser;
      if (!user) return;
      try {
        const docRef = doc(db, 'users', user.uid);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data();
          wallet.value = data.wallet || {}; pendingWallet.value = data.pendingWallet || {}; userAccount.value = data.account || ''; userPin.value = data.withdrawPin || null;
        }
        const q = query(collection(db, 'withdrawal_requests'), where('uid', '==', user.uid));
        const wSnap = await getDocs(q);
        withdrawalHistory.value = wSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0));
      } catch (e) { console.error("데이터 로드 실패:", e); }
    };

    const prepareWithdrawal = () => {
      if (!isValidAmount.value) return;
      if (!userPin.value) { pinSetupInput.value = ''; pinConfirmInput.value = ''; pinSetupError.value = ''; showPinSetupModal.value = true; } 
      else { pinInput.value = ''; pinError.value = ''; showWithdrawConfirmModal.value = true; }
    };

    const savePinNumber = async () => {
      if (pinSetupInput.value !== pinConfirmInput.value) { pinSetupError.value = '입력한 PIN 번호가 서로 다릅니다.'; return; }
      try {
        await updateDoc(doc(db, 'users', auth.currentUser.uid), { withdrawPin: pinSetupInput.value });
        userPin.value = pinSetupInput.value;
        alert('PIN 번호가 성공적으로 등록되었습니다.\n다시 출금 신청을 진행해주세요.');
        showPinSetupModal.value = false; showWithdrawConfirmModal.value = true; 
      } catch (e) { pinSetupError.value = '등록 중 오류가 발생했습니다.'; }
    };

    const executeWithdrawal = async () => {
      if (pinInput.value !== userPin.value) { pinError.value = 'PIN 번호가 일치하지 않습니다.'; return; }
      isProcessing.value = true;
      try {
        const amt = Number(withdrawAmount.value);
        await addDoc(collection(db, 'withdrawal_requests'), { uid: auth.currentUser.uid, amount: amt, fee: feeAmount.value, netAmount: netAmount.value, accountInfo: userAccount.value, status: 'PENDING', createdAt: serverTimestamp() });
        await updateDoc(doc(db, 'users', auth.currentUser.uid), { 'wallet.출금요청': increment(-amt) });
        alert(`출금 신청이 완료되었습니다.\n신청 금액: ${formatNumber(amt)}원 (수수료 차감 후 ${formatNumber(netAmount.value)}원 입금 예정)`);
        showWithdrawConfirmModal.value = false; withdrawAmount.value = '';
        await loadData();
      } catch (error) { alert('출금 신청 중 오류가 발생했습니다.'); } finally { isProcessing.value = false; }
    };

    const openDetailModal = async (type) => {
      showDetailModal.value = true;
      isModalLoading.value = true;
      modalDataList.value = [];
      const user = auth.currentUser;
      if (!user) return;

      try {
        const userCache = {};
        const getUserName = async (uid) => {
          if (!uid || uid === 'MASTER') return '-';
          if (userCache[uid]) return userCache[uid];
          const uSnap = await getDoc(doc(db, 'users', uid));
          if (uSnap.exists()) { userCache[uid] = uSnap.data().name; return userCache[uid]; }
          return '알수없음';
        };

        const resultList = [];
        let targetTypes = [];

        if (type === 'all') {
          modalTitle.value = '출금 가능 전체';
          targetTypes = ['판매', '매칭', '대수', '싸이클', '스타', '영업소관리', '영업소소개'];
        } else if (type === 'group_basic') {
          modalTitle.value = '판매/매칭/대수';
          targetTypes = ['판매', '매칭', '대수'];
        } else if (type === 'group_cycle') {
          modalTitle.value = '싸이클';
          targetTypes = ['싸이클'];
        } else if (type === 'group_etc') {
          modalTitle.value = '기타 (스타/영업소)';
          targetTypes = ['스타', '영업소관리', '영업소소개'];
        }

        // COMPLETED (출금 가능 전환 완료) 상태의 보너스만 로드
        const q = query(
          collection(db, 'bonus_history'), 
          where('uid', '==', user.uid), 
          where('status', '==', 'COMPLETED'),
          orderBy('createdAt', 'desc')
        );
        const snap = await getDocs(q);
        
        for (const d of snap.docs) {
          const data = d.data();
          if (targetTypes.includes(data.bonusType)) {
            const sourceName = await getUserName(data.sourceUid);
            resultList.push({
              id: d.id,
              bonusType: data.bonusType,
              amount: data.amount,
              description: data.description,
              createdAt: data.createdAt,
              sourceName: sourceName
            });
          }
        }
        modalDataList.value = resultList;
      } catch (error) {
        console.error("상세 내역 로드 중 오류:", error);
      } finally {
        isModalLoading.value = false;
      }
    };

    const closeDetailModal = () => {
      showDetailModal.value = false;
      modalDataList.value = [];
    };

    const handleLogout = async () => {
      try { await signOut(auth); router.push('/login'); } 
      catch (error) { console.error("로그아웃 실패:", error); }
    };

    const initCanvas = () => {
      if (!canvasRef.value) return; ctx = canvasRef.value.getContext('2d'); resizeCanvas(); window.addEventListener('resize', resizeCanvas);
      for (let i = 0; i < particleCount; i++) { particles.push({ x: Math.random() * canvasRef.value.width, y: Math.random() * canvasRef.value.height, vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4, radius: Math.random() * 1.2 + 0.5 }); }
      animate();
    };
    const resizeCanvas = () => { if (!canvasRef.value) return; canvasRef.value.width = window.innerWidth; canvasRef.value.height = window.innerHeight; };
    const animate = () => {
      if (!canvasRef.value || !ctx) return; ctx.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height);
      for (let i = 0; i < particles.length; i++) {
        let p = particles[i]; p.x += p.vx; p.y += p.vy; if (p.x < 0 || p.x > canvasRef.value.width) p.vx *= -1; if (p.y < 0 || p.y > canvasRef.value.height) p.vy *= -1;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2); ctx.fillStyle = 'rgba(255, 204, 0, 0.4)'; ctx.fill();
        for (let j = i + 1; j < particles.length; j++) { let p2 = particles[j]; let dx = p.x - p2.x; let dy = p.y - p2.y; let dist = Math.sqrt(dx * dx + dy * dy); if (dist < 100) { ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p2.x, p2.y); ctx.strokeStyle = `rgba(255, 204, 0, ${0.8 - dist / 100})`; ctx.lineWidth = 0.5; ctx.stroke(); } }
      } animationFrameId = requestAnimationFrame(animate);
    };

    onMounted(() => { loadData(); initCanvas(); });
    onBeforeUnmount(() => { window.removeEventListener('resize', resizeCanvas); if (animationFrameId) cancelAnimationFrame(animationFrameId); });

    return { 
      wallet, pendingWallet, availableBalance, pendingBalance, userAccount, withdrawAmount, 
      isValidAmount, feeAmount, netAmount, isProcessing, withdrawalHistory,
      showPinSetupModal, showWithdrawConfirmModal, pinSetupInput, pinConfirmInput, pinSetupError, pinInput, pinError,
      showDetailModal, isModalLoading, modalTitle, modalDataList, openDetailModal, closeDetailModal,
      formatNumber, formatDate, statusText, setAmount, loadData, prepareWithdrawal, savePinNumber, executeWithdrawal,
      handleLogout, canvasRef
    };
  }
}
</script>